import React, { useEffect, useState } from 'react';
import 'rc-banner-anim/assets/index.css';
import { Button, Col, Modal, Row } from 'antd';
import { PlayCircleOutlined } from '@ant-design/icons';
import ELearnVideo from '@/assets/video/eLearn.mp4';
import ReactPlayer from 'react-player';
import { useTranslation } from 'react-i18next';

const Banner = (props) => {
  const { dataSource, ...restProps } = props;
  const { titleWrapper, page } = dataSource;
  const [videoShow, setVideoShow] = useState(false);
  const [playing, setPlaying] = useState(false);
  const { t } = useTranslation();
  const closeView = () => {
    setPlaying(false);
    setVideoShow(false);
  };

  return (
    <div {...restProps} {...dataSource.wrapper}>
      <div {...page}>
        <Row>
          <Col xl={12} md={24}>
            <img src={require('@/assets/production/eLearn/eLearn-07.png')} style={{ width: '90%' }} />
          </Col>
          <Col xl={12} md={24}>
            <div {...titleWrapper}>
              <h1 {...titleWrapper.children[0]}>
                {t(titleWrapper.children[0].children)}
              </h1>
              <h2 {...titleWrapper.children[1]}>
                {titleWrapper.children[1].children}
              </h2>
              <div {...titleWrapper.children[2]}>
                <div dangerouslySetInnerHTML={{ __html: t(titleWrapper.children[2].children) }}></div>
              </div>
              <Button
                className={titleWrapper.children[3].className}
                shape="round"
                icon={<PlayCircleOutlined />}
                onClick={() => setVideoShow(true)}
              >
                {t('product.eLearn.videoIntroduction')}
              </Button>
            </div>
          </Col>
        </Row>
        <Modal
          title=""
          open={videoShow}
          footer={null}
          closable={false}
          afterClose={() => setPlaying(false)}
          onCancel={closeView}
          wrapClassName={'video-modal'}
        >
          <ReactPlayer
            url={ELearnVideo}
            controls={true}
            width={'100%'}
            height={'100%'}
            playing={playing}
            onPlay={() => setPlaying(true)}
            onPause={() => setPlaying(false)}
          />
        </Modal>
      </div>
    </div>
  );
};

export default Banner;
